export const getTranslationKeyByCode = (code = '') => {
  switch (code) {
    case 'activationRate30':
      return 'activationRate';
    case 'activationRate60':
      return 'activationRate';
    case 'activationRate90':
      return 'activationRate';
    default:
      return code;
  }
};

export type PercentageParts = {
  isDefined: boolean;
  isZero: boolean;
  arrow: '' | '▲' | '▼';
  abs?: number;
};

export const getPercentageParts = (raw: number | string | null | undefined): PercentageParts => {
  if (raw === null || raw === undefined) return { isDefined: false, isZero: false, arrow: '' };

  const n = typeof raw === 'string' ? parseFloat(raw) : raw;
  if (!Number.isFinite(n as number)) return { isDefined: false, isZero: false, arrow: '' };

  if (n === 0) return { isDefined: true, isZero: true, arrow: '', abs: 0 };
  return {
    isDefined: true,
    isZero: false,
    arrow: (n as number) > 0 ? '▲' : '▼',
    abs: Math.abs(n as number),
  };
};

const toTitleCase = (str: string) => {
  if (!str) return '';
  return String(str)
    .toLowerCase()
    .replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());
};

export const normalizeMetricSourceData = (kpiData: any, labelMapper?: (item: any) => string) => {
  if (!kpiData?.metricSourceData) return undefined;

  return {
    segments: kpiData.metricSourceData.map((item: any) => ({
      label: labelMapper ? labelMapper(item) : toTitleCase(item.keyName || item.key),
      value: item.value || 0,
      dataType: item.dataType,
    })),
  };
};
